export const PHISHING_PRIMARY_URL = "https://assets.bitwarden.com/security/v1/link-blocklist.txt";
export const PHISHING_MANIFEST_URL = "https://assets.bitwarden.com/security/v1/manifest.json";
export const PHISHING_PATCH_BASE_URL = "https://assets.bitwarden.com/security/v1/";
export const PHISHING_CHECKSUM_URL =
  "https://raw.githubusercontent.com/Phishing-Database/checksums/refs/heads/master/phishing-links-ACTIVE.txt.md5";
